import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../layout/index";
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  Drawer,
  IconButton,
  Modal,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Download from "../../components/download";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Header from "../../layout/header/Header";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import useAuth from "../../hooks/useAuth";
import * as io from "socket.io-client";

import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import useClipboard from "react-use-clipboard";
import { showError, showToast } from "../../constants/toast";
import Loader from "../../constants/Loader";
import {
  Cancel,
  Close,
  Delete,
  Edit,
  PauseCircle,
  PlayCircle,
  Send,
} from "@mui/icons-material";
import {
  useGenerateAiExplanationMutation,
  useChangeLanguageMutation,
  useIdentifyVocabMutation,
} from "../../services/utils";
import { CommonBody } from "../../types/General";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import HTMLReactParser from "html-react-parser";
import {
  useAddNoteTakingMutation,
  useEditNoteTakingByIdMutation,
  useLazyGetNoteTakingByIdQuery,
} from "../../services/noteTaking";
import { wrap } from "module";
import { handleDownload } from "../../utils/handleDownload";
import { useDownloadArticleMutation } from "../../services/article";
import useTranslation from "../../hooks/Translation";
let isConnectedFirstTime = false;
let originalText = "";
const sampleRate = 16000;
let mediaStream: any = null;
const getMediaStream = async () =>
  (mediaStream = await navigator.mediaDevices.getUserMedia({
    audio: {
      deviceId: "default",
      sampleRate: sampleRate,
      sampleSize: 16,
      channelCount: 1,
    },
    video: false,
  }));
const stopUsingMic = () => {
  if (mediaStream) {
    mediaStream.getTracks().forEach((track: any) => track.stop());
    console.log("Microphone usage stopped.");
  } else {
    console.log("No active microphone stream to stop.");
  }
};

interface WordRecognized {
  isFinal: boolean;
  text: string;
}

const EditNote = () => {
  const translate = useTranslation();
  const navigate = useNavigate();
  const user = useAuth();
  const [drawer, setDrawer] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [editCommentValue, setEditCommentValue] = useState("");
  const [editCommentIndex, setEditCommentIndex] = useState(0);
  const [editCommentOpen, setEditCommentOpen] = useState(false);
  const [vocabOpen, setVocabOpen] = useState(false);
  const [highlightedContent, setHighlightedContent] = useState<any>();

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: 587,
    bgcolor: "#353e3d",
    border: "1px solid #FFFFFF8A",
    boxShadow: 24,
    borderRadius: "10px",
    p: 3,
    maxHeight: "95vh",
    overflow: "auto",
  };
  const [dir, setDir] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [openAI, setOpenAI] = useState(false);
  const [aiDetail, setAiDetail] = useState("");
  const handleCloseAI = () => {
    setOpenAI(false);
  };
  const [open, setOpen] = React.useState<any>(false);
  const [textToCopy, setTextToCopy] = useState<string>("");
  const [isArabic, setIsArabic] = useState(false);
  const [downloadPdfFile2] = useDownloadArticleMutation();
  // const changeLanguage=()=>{
  //   if(isArabic)
  //   {
  //     setIsLoading(true);
  //     setIsArabic(false);
  //     SpeechRecognition.stopListening();
  //     setTimeout(()=>{
  //       setIsLoading(false);
  //     SpeechRecognition.startListening({ continuous: true, language: 'en'  })
  //       showToast("Listening Language Changed to English")
  //     },1000)
  //   }
  //   else
  //   {
  //     setIsLoading(true);
  //     setIsArabic(true);
  //     SpeechRecognition.stopListening();
  //     setTimeout(()=>{
  //       setIsLoading(false);
  //       SpeechRecognition.startListening({ continuous: true, language: 'ar'  })
  //       showToast("Listening Language Changed to Arabic")
  //     },1000)
  //   }
  // }
  const [isCopied, setCopied] = useClipboard(textToCopy, {
    successDuration: 1000,
  });

  const [isListening, setIsListening] = useState(false);
  async function requestMicrophoneAccess() {
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      return true;
    } catch (error) {
      return false;
    }
  }

  async function isMicrophoneAllowed() {
    const permissionStatus = await navigator.permissions.query({
      name: "microphone" as PermissionName,
    });
    return permissionStatus.state === "granted";
  }

  const handleListening = async () => {
    if (!isListening) {
      const hasPermission = await isMicrophoneAllowed();

      if (!hasPermission) {
        const requestAccess = await requestMicrophoneAccess();
        if (!requestAccess) {
          showError("Microphone permission disabled");
          return;
        }
      }

      // Start microphone listening logic here
    }
    if (isListening) {
      if (currentRecognition.trim().length) {
        setRecognitionHistory((prev: any) => [...prev, currentRecognition]);
        setCurrentRecognition("");
      }
      disconnect();
      // SpeechRecognition.stopListening();
      setIsListening(false);
    } else {
      isConnectedFirstTime = true;
      setEditMode(false);
      connect();
      // startListening();
      setIsListening(true);
    }
  };
  const [allComments, setAllComments] = useState<any>([
    //   {
    //   commentStartIndex:0,
    //   commentEndIndex:2,
    //   commentString:"23",
    //   commentTimeStamp:"10:23",
    //   commentValue:"sadnksankdnkmeklmekr"
    // },
  ]);
  console.log(allComments);

  const [aiExplain] = useGenerateAiExplanationMutation();
  const [changeLanguage] = useChangeLanguageMutation();

  const getAiDetail = async () => {
    // if (window.getSelection)
    //   console.log(window.getSelection()?.toString());
    // if (document.getSelection)
    //   console.log(document.getSelection()?.toString());
    // return;
    if (!recognitionHistory.join("").trim()) {
      showError(
        translate.noteTaking.addSomethingToGetDetail ||
          "Please add something to get detail"
      );
      return;
    }
    if (!document.getSelection()?.toString()) {
      showError(
        translate.noteTaking.selectSomethingToGetDetail ||
          "Please select something to get detail"
      );
      return;
    }
    setIsLoading(true);
    setPaused(true);
    SpeechRecognition.stopListening();
    setIsListening(false);
    try {
      const body = {
        text: document.getSelection()?.toString() || "Hi",
      };
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await aiExplain(encryptedBody).unwrap();
      if (response.status == 200) {
        setAiDetail(response?.data);
        setOpenAI(true);
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };
  const [identifyVocab] = useIdentifyVocabMutation();
  const handleVocab = async () => {
    if (!recognitionHistory?.join("").trim()) {
      showError(
        translate.noteTaking.speakSomethingBefore ||
          "Please speak something before"
      );
      return;
    }
    setIsLoading(true);
    try {
      const body = {
        text_data: recognitionHistory?.join("").trim() || textData,
      };
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await identifyVocab(encryptedBody).unwrap();
      if (response.status == 200) {
        let temp = recognitionHistory?.join("").trim() || textData;
        response?.data?.map((element: any) => {
          temp = temp?.replaceAll(
            element + " ",
            `<span style='background-color:rgb(185 154 36)'>${element + " "}</span>`
          );
        });
        console.log(response);
        setHighlightedContent(temp);
        setVocabOpen(true);
      }
    } catch (error: any) {
      console.log(error);
      showError(
        error?.data?.error ||
          error?.data?.message ||
          translate.errors.somethingWentWrong ||
          "Something went wrong"
      );
    }
    setIsLoading(false);
  };

  function convertToHTML(text: string) {
    const lines = text?.trim().split("\n");
    let html = "<ol>";
    let isSubList = false;
    let isParagraph = false;
    lines.forEach((line, index) => {
      const trimmedLine = line.trim();
      if (/^\d+\./.test(trimmedLine)) {
        if (isSubList) {
          html += "</ul>";
          isSubList = false;
        }
        if (isParagraph) {
          html += "</p>";
          isParagraph = false;
        }
        html += `<li><p>${trimmedLine.slice(3).trim()}</p>`;
      } else if (/^[a-z]+\./.test(trimmedLine)) {
        if (!isSubList) {
          html += "<ul>";
          isSubList = true;
        }
        if (isParagraph) {
          html += "</p>";
          isParagraph = false;
        }
        html += `<li><p>${trimmedLine.slice(2).trim()}</p>`;
      } else if (trimmedLine === "") {
        if (isParagraph) {
          html += "</p>";
          isParagraph = false;
        }
      } else {
        if (!isParagraph) {
          html += "<p>";
          isParagraph = true;
        }
        html += `${trimmedLine} `;
      }
      // Handle the end of the last item
      if (index === lines.length - 1) {
        if (isParagraph) {
          html += "</p>";
          isParagraph = false;
        }
        if (isSubList) {
          html += "</ul>";
          isSubList = false;
        }
      }
    });
    html += "</li></ol>";
    return html;
  }
  const generateHTMLcontent = (text: string) => {
    return text.replaceAll("\n", "<br>");
  };
  const downloadPdfData = async (data: any, type: number) => {
    if (!recognitionHistory.join("").trim()) {
      showError(
        translate.noteTaking.speakSomethingBefore ||
          "Speak something to download"
      );
      return;
    }
    setIsLoading(true);
    try {
      let html = "";
      html =
        '<html lang="ar"><meta charset="UTF-8"><style> body{font-family:"Arial", sans-serif;}</style></head><body style="background-color: white;" dir="auto">';
      // html = '<html><body style="background-color: white;">';
      html +=
        '<pre style="white-space: pre-wrap; font-family: Arial, sans-serif; background-color: #fff; border: 0px">';
      html += convertToHTML(textData).replaceAll(
        "<span style='background-color:rgb(185 154 36)'>",
        "<span>"
      );
      html += "</pre>";
      html += "</body></html>";

      const body = {
        html_text: html,
        type: type,
        // new: true,
      };
      console.log(body, "body for download ");

      if (html) {
        // setLoading(true);
        let encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await downloadPdfFile2({
          body: encryptedBody,
          id: id,
        }).unwrap();
        // setLoading(false);
        if (response?.status === 200) {
          setOpen(false);
          if (type == 3) {
            showToast(
              translate.toastMessages.pdfSharedOverEmail ||
                "PDF shared over email"
            );
          } else {
            handleDownload(
              response?.data,
              response?.data?.split("/")?.[
                response?.data?.split("/")?.length - 1
              ]
            );
            showToast(
              translate.toastMessages.downloadedSuccessfully ||
                "Downloaded Successfully"
            );
          }
          // window.open(response?.data || '');
        }
      }
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
    setIsLoading(false);
  };
  const getChangeLanguage = async (text: string) => {
    if (!text.trim().length) {
      showError(
        translate.noteTaking.speakSomethingBefore ||
          "Please speak something first"
      );
      return;
    }
    if (connection) disconnect();
    if (originalText) {
      setTextData(originalText);
      setRecognitionHistory([originalText]);
      originalText = "";
      return;
    }
    setIsLoading(true);
    setPaused(true);
    // SpeechRecognition.stopListening();
    setIsListening(false);
    try {
      const body = {
        text,
      };
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await changeLanguage(encryptedBody).unwrap();
      if (response.status == 200) {
        originalText = recognitionHistory.join("") || textData;
        setTextData(response?.data);
        setRecognitionHistory([response?.data]);
      }
    } catch (error: any) {
      if (error?.status)
        showError(
          error?.data?.message ||
            error?.data?.message ||
            error?.status ||
            translate.errors.somethingWentWrong
        );
      console.log(error);
    }
    setIsLoading(false);
  };
  const [newComment, setNewComment] = useState("");
  const handleAddNewComment = () => {
    if (!isConnectedFirstTime) {
      showError("Please speak something to add comment");
      return;
    }
    if (!newComment) {
      showError(
        translate.noteTaking.pleaseWriteSomeComment ||
          "Please write some comment"
      );
      return;
    }
    // if (!textData){
    //   showError("Please Speak Something")
    //   return;}
    setAllComments([
      ...allComments,
      {
        commentStartIndex: textData.lastIndexOf(" "),
        commentEndIndex: textData?.lastIndexOf(""),
        commentString: textData?.split(" ")?.[textData?.split(" ")?.length - 1],
        commentTimeStamp: time,
        commentValue: newComment,
      },
    ]);
    setNewComment("");
  };
  const startListening = () => {
    if (originalText) {
      setTextData(originalText);
      originalText = "";
    }
    SpeechRecognition.startListening({ continuous: true, language: "en-US" });
  };
  const { transcript, browserSupportsSpeechRecognition } =
    useSpeechRecognition();
  const [textData, setTextData] = useState("");
  const [textData2, setTextData2] = useState("");
  // useEffect(() => {
  //   // transcript.length,textData2.length

  //   console.log(
  //     "transcript.length,textData2.length :",
  //     transcript.length,
  //     textData2.length,
  //   );
  //   console.log("MYSELF", transcript?.slice(0, textData2.length));
  //   setTextData(
  //     textData + transcript?.slice(textData2.length, transcript.length),
  //   );
  //   setTextData2(transcript);
  // }, [transcript]);

  const handleClose = () => {
    setOpen(false);
  };
  const [time, setTime] = useState("00:00");
  const [seconds, setSeconds] = useState(0);
  const [paused, setPaused] = useState(true);

  const highlight = (finalString: string, highlight: any[]) => {
    let final = finalString.split("");
    console.log(final.map((data, index) => [index, data]));
    for (let key in highlight) {
      final.splice(
        highlight[key][0],
        0,
        "<span style='background-color:#cccc00'>"
      );
      console.log("1", final.join(""));
      highlight = highlight.map((data) => {
        return [data[0] + 1, data[1] + 1];
      });
      final.splice(highlight[key][1] + 1, 0, "</span>");
      console.log("2", final.join(""));
      highlight = highlight.map((data) => {
        return [data[0] + 1, data[1] + 1];
      });
    }
    console.log("final.join('') :", final.join(""));
    return final.join("");
  };
  const [addNote] = useAddNoteTakingMutation();
  const [editById] = useEditNoteTakingByIdMutation();
  const handleAddUpdateNote = async () => {
    disconnect();
    if (!editMode && !recognitionHistory.join("").trim().length) {
      showError(
        translate.noteTaking.speakSomethingBefore ||
          "Please speak something first"
      );
      return;
    }
    if (editMode && !textData.trim()) {
      showError("No Data to save, please add some data");
      return;
    }
    setPaused(true);
    try {
      setIsLoading(true);
      const body: Record<string, any> = {
        comments: allComments,
        text_timestamp: time,
        binary_data: editMode ? textData : recognitionHistory.join(""),
        type: 2,
      };
      if (!id) {
        body["file_name"] = Date.now();
      }
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = id
        ? await editById({ id: id as string, body: encryptedBody }).unwrap()
        : await addNote(encryptedBody).unwrap();
      if (response.status == 200) {
        showToast(
          id
            ? translate.noteTaking.noteUpdatedSuccessfully ||
                "Note updated successfully"
            : translate.noteTaking.noteAddedSuccessfully ||
                "Note added successfully"
        );
        navigate("/note-taking");
      }
    } catch (error: any) {
      console.log(error);
      showError(
        error?.data?.message ||
          translate.errors.somethingWentWrong ||
          "Something went wrong"
      );
    }
    setIsLoading(true);
  };

  const [getDataById] = useLazyGetNoteTakingByIdQuery();
  const getDataByIdList = async () => {
    setIsLoading(true);
    try {
      const response = await getDataById({ id }).unwrap();
      if (response.status == 200) {
        setTextData(response?.data?.binary_data);
        setTextData2(response?.data?.binary_data);
        setRecognitionHistory([response?.data?.binary_data]);
        setAllComments(response?.data?.comments);
        setTime(response?.data?.text_timestamp);
      }
    } catch (error: any) {
      showError(error?.data?.message || error?.data?.message);
      console.log(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    let intervalId: any = null;
    if (!paused) {
      intervalId = setInterval(() => {
        setSeconds(seconds + 1);
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        setTime(`${padZero(minutes)}:${padZero(remainingSeconds)}`);
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [seconds, paused]);

  const padZero = (num: any) => (num < 10 ? `0${num}` : num);
  useEffect(() => {
    SpeechRecognition.abortListening();
    setPaused(true);
    setIsListening(false);
    return () => {
      SpeechRecognition.abortListening();
      disconnect();
    };
  }, [editMode]);
  useLayoutEffect(() => {
    if (originalText) setDir("rtl");
    else setDir("");
    // if(originalText)
    // document.dir = 'rtl';
    // else
    // document.dir=''
  }, [textData]);
  useEffect(() => {
    if (id) getDataByIdList();
    originalText = "";
    isConnectedFirstTime = false;
  }, []);
  const [connection, setConnection] = useState<io.Socket>();
  const [currentRecognition, setCurrentRecognition] = useState<string>("");
  const [recognitionHistory, setRecognitionHistory] = useState<string[]>([]);
  console.log("recognitionHistory :", recognitionHistory);
  const [isRecording, setIsRecording] = useState<boolean>(false);
  const [recorder, setRecorder] = useState<any>();
  const processorRef = useRef<any>();
  const audioContextRef = useRef<any>();
  const audioInputRef = useRef<any>();

  const speechRecognized = (data: WordRecognized) => {
    if (data.isFinal) {
      setCurrentRecognition("");
      setRecognitionHistory((old) => [...old, data.text]);
    } else setCurrentRecognition(data.text + "...");
  };

  useEffect(() => {
    console.log("\n\nrecognitionHistory", recognitionHistory);
  }, [recognitionHistory]);

  const connect = () => {
    try {
      connection?.disconnect();
      if (originalText) {
        setTextData(originalText);
        setRecognitionHistory([originalText]);
        originalText = "";
      }
      const socket = io.connect("https://whizzopythonapi.appgrowthcompany.com");
      socket.on("connect", () => {
        console.log("connected", socket.id);
        setPaused(false);
        setIsListening(true);

        setConnection(socket);
      });

      socket.emit("send_message", "hello world");

      socket.emit("startGoogleCloudStream");

      socket.on("receive_message", (data: any) => {
        console.log("received message", data);
      });

      socket.on("receive_audio_text", (data: any) => {
        speechRecognized(data);
        console.log("received audio text", data);
      });

      socket.on("disconnect", () => {
        console.log("disconnected", socket.id);
      });
      setPaused(false);
    } catch (error: any) {
      console.log(error);
    }
  };

  const disconnect = () => {
    try {
      if (!connection) return;
      setPaused(true);
      setIsListening(false);
      connection?.emit("endGoogleCloudStream");
      connection?.disconnect();
      processorRef.current?.disconnect();
      audioInputRef.current?.disconnect();
      audioContextRef.current?.close();
      setConnection(undefined);
      setRecorder(undefined);
      setIsRecording(false);
      stopUsingMic();
      setPaused(true);
    } catch (error: any) {
      console.log(error);
    }
  };

  useEffect(() => {
    (async () => {
      if (connection) {
        if (isRecording) {
          return;
        }
        try {
          const stream = await getMediaStream();

          audioContextRef.current = new window.AudioContext();

          await audioContextRef.current.audioWorklet.addModule(
            "/src/worklets/recorderWorkletProcessor.js"
          );

          audioContextRef.current.resume();

          audioInputRef.current =
            audioContextRef.current.createMediaStreamSource(stream);

          processorRef.current = new AudioWorkletNode(
            audioContextRef.current,
            "recorder.worklet"
          );

          processorRef.current.connect(audioContextRef.current.destination);
          audioContextRef.current.resume();

          audioInputRef.current.connect(processorRef.current);

          processorRef.current.port.onmessage = (event: any) => {
            const audioData = event.data;
            connection.emit("send_audio_data", { audio: audioData });
            console.log("audioData :", audioData);
          };
          setIsRecording(true);
        } catch (error: any) {
          showError(error || translate.errors.somethingWentWrong);
          console.log("errror", error);
        }
      } else {
        console.error("No connection");
      }
    })();
    return () => {
      if (isRecording) {
        processorRef.current?.disconnect();
        audioInputRef.current?.disconnect();
        if (audioContextRef.current?.state !== "closed") {
          audioContextRef.current?.close();
        }
      }
    };
  }, [connection, isRecording, recorder]);

  return (
    <>
      <Loader isLoad={isLoading} />
      <div className="sde_br_mn">
        <div className="sde_mn_cnt">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              className="btnn btn-primary h_46"
              // disabled={!textData}
              onClick={() => {
                if (editMode) {
                  setRecognitionHistory([textData]);
                  setEditMode(!editMode);
                } else {
                  if (currentRecognition.trim().length) {
                    setRecognitionHistory((prev: any) => [
                      ...prev,
                      currentRecognition,
                    ]);
                    setTextData(
                      [recognitionHistory, currentRecognition].join("")
                    );
                    setTextData2(
                      [recognitionHistory, currentRecognition].join("")
                    );
                    setCurrentRecognition("");
                  } else {
                    setTextData(recognitionHistory.join(""));
                    setTextData2(recognitionHistory.join(""));
                  }
                  setEditMode(!editMode);
                  if (connection) disconnect();
                }
              }}
            >
              {editMode
                ? translate.global.save || "Save"
                : translate.global.edit || "Edit"}
            </Button>
            <Button className="btnn h_46" onClick={handleAddUpdateNote}>
              {id
                ? translate.noteTaking.updateNote || "Update Note"
                : translate.noteTaking.addNote || "Add Note"}
            </Button>
          </div>
          <div className="edt_asgn edt_nte nt_w100">
            <div className="inner_box">
              {/* <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as ir default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). It is a long search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injectedand the like).It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packagnd the like).</p> */}
              {/* {!browserSupportsSpeechRecognition &&
                  "BROWSER doesn't SUPPORT AUDIO RECOGNITION"} */}
              {!editMode &&
                !recognitionHistory.length &&
                !currentRecognition && (
                  <div
                    style={{
                      // height: "85px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      // marginTop: "15%"
                    }}
                  >
                    {" "}
                    <h3
                      className="h3_font"
                      style={{ fontSize: "xxx-large", color: "darkgrey" }}
                    >
                      {translate.noteTaking.speakSomething || "Speak Something"}
                    </h3>
                  </div>
                )}
              <div
                className="overFlow_box"
                style={{ overflow: "auto", maxHeight: "420px" }}
                dir={dir}
                // dir="auto"
              >
                <p>
                  {editMode ? (
                    <TextField
                      multiline
                      minRows={5}
                      maxRows={15}
                      className="text_field"
                      value={textData}
                      sx={{ color: "#000" }}
                      onChange={(e) => setTextData(e.target.value)}
                    />
                  ) : (
                    // (
                    //   HTMLReactParser(
                    //     highlight(
                    //       textData,
                    //       allComments.map((data: any) => [
                    //         data.commentStartIndex,
                    //         data.commentEndIndex,
                    //       ]),
                    //     ),
                    //   )
                    // )
                    // HTMLReactParser(textData.replaceAll('\n', '<br>'))
                    recognitionHistory.map((tx, idx) => (
                      <span key={idx}>{tx}</span>
                    ))
                  )}
                  <p>{currentRecognition}</p>
                </p>
              </div>
            </div>
            <>
              <div className="container">
                {/* {transcript} */}
                {/* <div className="main-content" onClick={() =>  setTextToCopy(transcript)}>
                    {transcript}
                </div> */}

                {/* <div className="btn-style">

                    <button onClick={setCopied}>
                        {isCopied ? 'Copied!' : 'Copy to clipboard'}
                    </button>
                    <button onClick={startListening}>Start Listening</button>
                    <button onClick={SpeechRecognition.stopListening}>Stop Listening</button>

                </div> */}
              </div>
            </>
            <div className="prfl_btn edtnt Edt_nt">
              <Button
                className="btnn h_46"
                onClick={() =>
                  getChangeLanguage(recognitionHistory.join("") || textData)
                }
              >
                {translate.global.changeLanguage || "Change Language"}
              </Button>
              <Button className="btnn h_46" onClick={() => getAiDetail()}>
                {translate.global.aIExplanation || "AI Explanation"}
              </Button>
              <Button className="btnn h_46" onClick={handleVocab}>
                {translate.global.highlightVocab || "Highlight Vocabulary"}
              </Button>
              <Button
                className="btnn h_46"
                onClick={() =>
                  allComments?.length
                    ? setDrawer(true)
                    : showError("No comments added")
                }
              >
                {translate.noteTaking.comments || "Comments"}
              </Button>
              <div className="record_btn">
                <figure>
                  {!id &&
                    (isListening ? (
                      <ul className="wave-menu">
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                      </ul>
                    ) : (
                      <ul className="wave-menu2">
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                      </ul>
                    ))}
                  {/* <img src="/static/images/note-start.png" alt=""></img> */}
                </figure>
                <figure className="timer" style={{ margin: 0, padding: 0 }}>
                  {time}
                </figure>
                {!id && (
                  <Box
                    className="rcrd_btn h_46"
                    style={{ cursor: "pointer" }}
                    onClick={handleListening}
                  >
                    {isListening ? <PauseCircle /> : <PlayCircle />}
                  </Box>
                )}
              </div>

              <Button
                className="btnn h_46"
                onClick={() => {
                  setTextData(recognitionHistory.join("").trim());
                  setOpen(true);
                }}
              >
                {translate.global.download || "Download"}
              </Button>
            </div>
          </div>
          <Drawer
            className="drawer"
            anchor="right"
            open={drawer}
            onClose={() => {
              setDrawer(false);
            }}
          >
            <Card className="cmnts_Bx">
              <IconButton
                style={{ position: "absolute", right: 30, top: 20 }}
                onClick={() => {
                  setNewComment("");
                  setDrawer(false);
                }}
              >
                <Cancel color="error" />
              </IconButton>
              <Typography style={{ fontSize: "20px" }}>
                {translate.noteTaking.comments || "Comments"}
              </Typography>
              <CardContent
                style={{ width: "400px", height: "100%", padding: "0" }}
              >
                <div className="prev_ed_rt">
                  <div>
                    <ul
                      style={{
                        height: "500px",
                        overflow: "auto",
                        paddingRight: "10px",
                      }}
                    >
                      {allComments?.length ? (
                        allComments?.map((data: any, index: number) => {
                          return (
                            <li>
                              <div className="cmnt_Inr">
                                {/* <div>{data.commentString}</div> */}
                                <div className="cmnt_vluE">
                                  {data.commentValue?.length < 30 ? (
                                    data.commentValue
                                  ) : (
                                    <Tooltip title={data.commentValue}>
                                      <div>
                                        {data.commentValue.slice(0, 30) + "..."}
                                      </div>
                                    </Tooltip>
                                  )}
                                  <div>
                                    <IconButton
                                      onClick={() => {
                                        setEditCommentIndex(index);
                                        setEditCommentOpen(true);
                                        setEditCommentValue(data.commentValue);
                                      }}
                                    >
                                      <Edit />
                                    </IconButton>
                                  </div>
                                </div>
                                <div className="tm_count">
                                  <span className="bg_time">
                                    {data.commentTimeStamp}
                                  </span>

                                  <div>
                                    <IconButton
                                      onClick={() => {
                                        showToast(
                                          "Comment deleted successfully"
                                        );
                                        setAllComments((prev: any) =>
                                          prev.filter(
                                            (data: any, index2: number) =>
                                              index2 != index
                                          )
                                        );
                                      }}
                                    >
                                      <Delete />
                                    </IconButton>
                                  </div>
                                </div>
                              </div>
                            </li>
                          );
                        })
                      ) : (
                        <div
                          style={{
                            color: "#fff",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                          }}
                        >
                          {translate.noteTaking.noComments || "No Comments"}
                        </div>
                      )}
                    </ul>
                  </div>
                  {!id && (
                    <div
                      className="cmnt_btM"
                      style={{
                        display: "flex",
                        position: "fixed",
                        bottom: "60px",
                        width: "389px",
                      }}
                    >
                      <TextField
                        fullWidth
                        value={newComment}
                        onChange={(e) => setNewComment(e.target.value)}
                        inputProps={{
                          style: { color: "#000", paddingRight: "40px" },
                          maxLength: 50,
                        }}
                        className="text_field"
                      />
                      <IconButton onClick={handleAddNewComment}>
                        <Send />
                      </IconButton>
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
          </Drawer>
        </div>
      </div>
      <Download
        open={open}
        setOpen={setOpen}
        handleClose={handleClose}
        downloadPdf={downloadPdfData}
        note={translate.noteTaking.notetaking || "Note taking"}
      />
      <Dialog
        open={vocabOpen}
        onClose={() => setVocabOpen(false)}
        className="vocab_highlight"
      >
        <DialogContent>
          <div className="vocab_head">
            <h2>
              {translate.global.highlightVocab || "Highlighted Vocabulary"}
            </h2>
            <IconButton onClick={() => setVocabOpen(false)}>
              <Close color="error" />
            </IconButton>
          </div>
          <div className="vocab_body">
            {highlightedContent &&
              HTMLReactParser(highlightedContent.replaceAll("\n", "<br>"))}
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={editCommentOpen}
        onClose={() => {
          setEditCommentOpen(false);
        }}
      >
        <DialogContent className="cmnt_mN">
          {/* <Card style={{ width: "500px" }}> */}
          <div className="cmnt_inR">
            {/* <div>
                {" "}
                Comment Word : {allComments?.[editCommentIndex]?.commentString}
              </div> */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                marginBlock: "15px",
              }}
            >
              {" "}
              <span style={{ display: "block", width: "100%" }}>
                {translate.noteTaking.comment || "Comment :"}{" "}
              </span>{" "}
              <div className="cmnt_txT">
                <TextField
                  fullWidth
                  value={editCommentValue}
                  onChange={(e) => setEditCommentValue(e.target.value)}
                  inputProps={{
                    style: { color: "#000" },
                  }}
                  className="text_field"
                />
                <IconButton
                  onClick={() => {
                    setAllComments((prev: any) => {
                      return prev.map((data: any, index: number) => {
                        if (index == editCommentIndex) {
                          return { ...data, commentValue: editCommentValue };
                        }
                        return data;
                      });
                    });
                    setEditCommentValue("");
                    setEditCommentOpen(false);
                  }}
                >
                  <Send />
                </IconButton>
              </div>
            </div>
          </div>
          {/* </Card> */}
        </DialogContent>
      </Dialog>
      <Modal
        open={openAI}
        onClose={handleCloseAI}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modall"
      >
        <Box
          sx={style}
          component={"div"}
          className="text_center how_to_modal"
          dir="auto"
        >
          <p className="close_icon" onClick={handleCloseAI}>
            <Close />
          </p>
          <figure>
            <img src="/static/images/bulb.svg" alt="icon"></img>
          </figure>
          <Typography variant="h6" component="h2">
            {aiDetail
              ? aiDetail?.slice(0, aiDetail?.indexOf("\n"))
              : "How to learn trignomentery table easily?"}
          </Typography>
          <Typography sx={{ mt: 2, textAlign: "start" }}>
            {aiDetail
              ? HTMLReactParser(
                  generateHTMLcontent(
                    aiDetail.slice(aiDetail?.indexOf("\n"), aiDetail?.length)
                  )
                )
              : `It is a long established fact that a reader will be distracted by
            the readable content of a page when looking at its layout. The point
            of using Lorem Ipsum is that it has a more-or-less normal
            distribution of letters, as opposed to using 'Content here, content
            here', making it look like readable English. Many desktop publishing
            packages and web page editors now use Lorem Ipsum as their default
            model text, and a search for 'lorem ipsum' will uncover many web
            sites still in their infancy. Various versions have evolved over the
            years, sometimes by accident, sometimes on purpose (injected humour
            and the like).`}
          </Typography>
        </Box>
      </Modal>
    </>
  );
};
export default EditNote;
